import React from 'react';
import { queries } from '../../../graphql/graphql';
import PaginatedAdminList, { ListItem } from '../../../components/containers/PaginatedAdminList';
import { ProposalCard } from '../../../components/Proposals/ProposalCard';
import type { Proposal } from '../../../types/proposal';
import { Col, Row } from 'antd';

const ContractorProposalCard: React.FC<{
  item: ListItem;
  refetch: () => void;
  prefix: string;
  roles?: string[];
}> = ({ item }) => {
  const proposal = item as Proposal;
  return (
    <ProposalCard
      proposal={proposal}
      viewPath={`/proposal/${proposal.id}`}
      editPath={`/contractor/proposal/edit/${proposal.id}`}
    />
  );
};

export const ContractorProposalsList: React.FC = () => {
  return (
    <div
      style={{
        display: 'block',
        width: '100%',
        padding: '2em',
        textAlign: 'left',
      }}>
      <Row gutter={[16, 16]} style={{ height: '100%', width: '100%', margin: 0 }}>
        <Col span={24}>
          <PaginatedAdminList
            prefix="proposal"
            query={queries.proposal.MY_PROPOSALS}
            inline={false}
            editable={false}
            canCreate={true}
            adminView={false}
            createPath="/contractor/proposal/new"
            CustomCard={ContractorProposalCard}
            defaultPageSize={12}
          />
        </Col>
      </Row>
    </div>
  );
};
